export var FormulaStrings = {
    numberExpected: "#NUMBER EXPECTED",
    incorrectArgumentSet: "#INCORRECT ARGUMENT SET",
    unrecognizedFunction: "#UNRECOGNIZED FUNCTION"
};
//# sourceMappingURL=FormulaStrings.js.map